import ModalPrompt from "@/app/components/ui/Modals/Prompt";
// import { useForm } from "react-hook-form";

export interface ILabReportsRequestSamplePickupProps {}

const RequestSamplePickupContent = () => {
  //   const formHook = useForm<ILabReportsRequestSamplePickupProps>({
  //     mode: "onChange",
  //     defaultValues: {},
  //   });
  return (
    <div className="p-4 bg-white">
      <div className="flex mb-4">
        <div className="text-black text-sm font-normal w-48">Invoice Number</div>
        <div className="text-sm font-medium">IN-0012</div>
      </div>
      <div className="flex mb-4">
        <div className="text-black text-sm font-normal w-48">Requisition ID</div>
        <div className="text-sm font-medium">LAB010125_GCR01</div>
      </div>
      <div className="flex mb-4">
        <div className="text-black text-sm font-normal w-48">Customer</div>
        <div className="text-sm font-medium">
          <p>Sunidhi Kashyap</p>
          <p>9043232435</p>
        </div>
      </div>
      <div className="flex mb-4">
        <div className="text-black text-sm font-normal w-48">Pet</div>
        <div className="text-sm font-medium">
          <p>Coco</p>
          <p>Canine, Golden Retriever, Female | 2yrs 3mo</p>
        </div>
      </div>
      <div className="flex mb-4">
        <div className="text-black text-sm font-normal w-48">Doctor</div>
        <div className="text-sm font-medium">Dr. Shefali</div>
      </div>
      <div className="flex mb-4">
        <div className="text-black text-sm font-normal w-48">Test</div>
        <div className="text-sm font-medium">CBC</div>
      </div>
    </div>
  );
};
const RequestSamplePickupModal = () => {
  return (
    <ModalPrompt
      modalId="REQUEST_SAMPLE_PICKUP_MODAL"
      showIcon={false}
      contentOverflow={true}
      titleIcon=""
      dialogClassName="sm:my-8 sm:w-full sm:max-w-2xl sm:p-6"
      button={{
        primaryButtonText: "Save",
        secondaryButtonText: "Cancel",
        primaryButtonClassname:
          "px-6 cursor-pointer py-[9px] bg-sky-900 hover:bg-sky-900 rounded-md border border-slate-400 border-opacity-20 justify-center items-center gap-2 flex",
        primaryCallback: () => {},
        shouldHideOnClick: true,
      }}
      title="Request Sample Pickup"
      content={<RequestSamplePickupContent />}
    />
  );
};

export default RequestSamplePickupModal;
